/* eslint-disable max-lines */
import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress, IconButton, LinearProgress, makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import DrugEdit from './Drug/DrugEdit';
import DrugView from './Drug/DrugView';
import { useDispatch, useSelector } from 'react-redux';
import {
    editPrescription,
    createPrescription,
    deletePrescription
} from '../../redux/Drug/DrugAction';
import { addMessage } from '../../redux/General/GeneralAction';
import { DrugHeader } from './Drug/DrugView';
import PrescriptionHeader from './PrescriptionHeader';
import { searchDrugs, setDrugs, getDrugsDetail } from '../../redux/Drug/DrugAction';
import * as moment from 'moment-jalaali';
import useCheckMobileScreen from '../../hooks/useWidth';
import MessagesContext from '../../contexts/messagesContext';
import LanguageContext from '../../contexts/languageContext';
import { AlertDialog } from '../UI';
import { getFullDate } from '../../utils/dateTimeUtil';

const styles = makeStyles((theme) => ({
    body: {
        border: 'solid 1px #bbbbbb',
        borderRadius: '7px',
        padding: '30px 40px',
        position: 'relative',
        direction: 'ltr',
        textAlign: 'left',
        // maxWidth: '900px',
        margin: 'auto',
        marginBottom: '35px',
        [theme.breakpoints.down(1025)]: {
            backgroundColor: '#fff',
            borderRadius: '8px 0 0 8px',
            border: 'none',
            padding: '24px 0 0px 0px',
            direction: 'ltr',
            textAlign: 'left',
            marginBottom: '24px',
            '& form': {
                overflowX: 'auto'
            }
        }
    },

    bodyMobile: {
        backgroundColor: '#fff',
        borderRadius: '8px 0 0 8px',
        padding: '24px 0 24px 0px',
        direction: 'ltr',
        textAlign: 'left',
        marginBottom: '24px'

        // display: "flex",
        // flexDirection:"column"
    },
    drugItemWrapper: {
        paddingLeft: '24px'
    },
    editActions: {
        display: 'flex',
        justifyContent: 'flex-start',
        lineHeight: '.8em',
        flexDirection: 'row-reverse',
        position: 'sticky',
        left: '0px'
    },
    iconButton: {
        position: 'relative',
        bottom: '-20px',
        cursor: 'pointer',
        fontFamily: 'inherit',
        [theme.breakpoints.down(1025)]: {
            bottom: 0
        }
    },
    cancel: {
        color: '#ef1734',
        width: '20px',
        height: '20px'
    },
    done: {
        color: '#1b90fa',
        width: '20px',
        height: '20px'
    },
    fontText: {
        fontFamily: 'inherit',
        fontSize: '14px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.79',
        letterSpacing: 'normal',
        textAlign: 'right'
    },
    saveText: {
        color: '#1b90fa'
    },
    cancelText: {
        color: '#ef1734'
    },
    submitLoaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        bottom: '-20px',
        cursor: 'pointer',
        padding: '12px',
        [theme.breakpoints.down(1025)]: {
            bottom: 0
        }
    },
    drugEditLoader: {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px'
    }
}));
const Prescription = ({ prescription, addNew, patientId, handleCancel, notEditClinical }) => {
    const isMobile = useCheckMobileScreen();
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const { messages } = useContext(MessagesContext);
    const [editable, setEditable] = useState(false);
    const [alert, setAlert] = useState({
        open: false,
        text: ''
    });
    const emptyDrug = {
        drug: null,
        drug_form: '',
        drug_strength: '',
        description: ''
    };
    const emptyPrescription = {
        prescriber: null,
        prescribed: new Date(),
        prescribed_drugs: [emptyDrug]
    };
    const [submitted, setSubmitted] = useState(false);
    const [editedPrescription, setEditedPrescription] = useState(() => {
        if (addNew) {
            return emptyPrescription;
        } else {
            return prescription;
        }
    });
    useEffect(() => {
        if (!addNew) {
            setEditedPrescription(prescription);
        }
    }, [prescription]);
    const dispatch = useDispatch();
    const drugs = useSelector((state) => {
        if (state.drug?.drugs) {
            return state.drug.drugs[addNew ? 'new' : prescription.id];
        }
        return null;
    });
    if (!prescription && !addNew) {
        return null;
    }
    const handleChangeDate = (event) => {
        setEditedPrescription((editedPrescription) => ({
            ...editedPrescription,
            prescribed: event
        }));
    };
    const handleDone = () => {
        let flag = false;
        for (let item of editedPrescription.prescribed_drugs) {
            if (!item.drug && editedPrescription.prescribed_drugs.length === 1) {
                dispatch(
                    addMessage({
                        text: messages.validations.emptyPrescription,
                        status: 400
                    })
                );
                flag = true;
            }
            if (item.drug && (!item.drug_form || !item.drug_strength)) {
                dispatch(
                    addMessage({
                        text: messages.validations.incompletePrescription,
                        status: 400
                    })
                );
                flag = true;
            }
            if (flag) break;
        }
        if (flag) return;
        if (!editedPrescription.prescribed) {
            setEditedPrescription((editedPrescription) => ({
                ...editedPrescription,
                prescribed: moment(new Date()).format('YYY-MM-DD')
            }));
        }
        if (addNew) {
            handleCreatePrescription();
        } else {
            handleEditPrescription();
        }
    };
    const setParameter = () => {
        const param = {
            prescribed: moment(editedPrescription.prescribed),
            prescribed_drugs: editedPrescription.prescribed_drugs
                .map((val) => {
                    if (val.drug) {
                        return {
                            drug_id: val.drug.id,
                            drug_form_id: val.drug_form?.id || val.drug_form,
                            drug_strength_id: val.drug_strength?.id || val.drug_strength,
                            description: val.description
                        };
                    }
                    return null;
                })
                .filter((val) => val),
            patient_id: patientId
        };
        return param;
    };
    const handleCreatePrescription = async () => {
        setSubmitted(true);
        const param = setParameter();
        await dispatch(createPrescription(param));
        setSubmitted(false);
        cancelEditing();
    };
    const handleEditPrescription = async () => {
        setSubmitted(true);
        const param = setParameter();
        await dispatch(editPrescription(prescription.id, param));
        setEditable(false);
        setSubmitted(false);
        cancelEditing();
    };
    const handleRemoveDrug = (index) => {
        if (editedPrescription.prescribed_drugs?.length < 2) {
            setEditedPrescription(emptyPrescription);
        } else {
            let edited = { ...editedPrescription };
            edited.prescribed_drugs.splice(index, 1);
            if (edited) {
                setEditedPrescription(edited);
            }
        }
    };
    const handleAddEmptyDrug = () => {
        setEditedPrescription((editedPrescription) => ({
            ...editedPrescription,
            prescribed_drugs: [...editedPrescription.prescribed_drugs, { ...emptyDrug }]
        }));
    };
    const handleEditDrug = (params, index) => {
        const { value, prop } = params;
        if (value === null || value === undefined || !prop) {
            return;
        }
        let newPrescription = JSON.parse(JSON.stringify(editedPrescription));
        let newDrugList = newPrescription.prescribed_drugs;
        const prevDrug = newDrugList[index];
        let newDrug = { ...prevDrug, [prop]: value };

        if (prop === 'drug') {
            const isDuplicate = checkDuplicateDrugEntry(value, index);
            if (isDuplicate) {
                return false;
            }
            // empty form and strengths as drug changes
            newDrug = { ...emptyDrug, [prop]: value, description: prevDrug.description };

            // add empty row to the drugs list
            if (!prevDrug?.drug && index === editedPrescription.prescribed_drugs.length - 1) {
                newDrugList = [...newDrugList, { ...emptyDrug }];
            }
        }
        newDrugList.splice(index, 1, newDrug);

        setEditedPrescription((editedPrescription) => {
            return {
                ...editedPrescription,
                prescribed_drugs: newDrugList
            };
        });
        return true;
    };
    const checkDuplicateDrugEntry = (drug, index) => {
        const foundIndex = editedPrescription?.prescribed_drugs?.findIndex(
            (val) => val.drug?.id === drug.id
        );
        if (foundIndex > -1 && foundIndex !== index) {
            dispatch(
                addMessage({
                    text: 'این دارو در نسخه انتخاب شده است .',
                    status: 400
                })
            );
            return true;
        }
        return false;
    };
    const handleSearchDrugs = (value) => {
        let id = addNew ? 'new' : prescription.id;
        if (value) {
            dispatch(searchDrugs(value, id));
        } else {
            dispatch(setDrugs([], id));
        }
    };
    const makePrescriptionEditable = async () => {
        setEditable(true);
        const prescribedDrugs = prescription?.prescribed_drugs?.map((val) => val.drug.id).join();
        if (prescribedDrugs) {
            await dispatch(getDrugsDetail(prescribedDrugs, prescription?.id));
        }

        handleAddEmptyDrug();
    };
    const cancelEditing = (val) => {
        if (addNew) {
            handleCancel();
        } else {
            if (val === 'isCancelButton') {
                setEditedPrescription(prescription);
            }
            setEditable(false);
        }
    };
    const prescriptionOptions = () => {
        if (editable || addNew) {
            return (
                <div className={classes.editActions}>
                    {submitted ? (
                        <div className={classes.submitLoaderContainer}>
                            <CircularProgress size={18} thickness={2} />
                        </div>
                    ) : (
                        <IconButton className={classes.iconButton} onClick={handleDone}>
                            <span className={`${classes.saveText}  ${classes.fontText}`}>
                                {messages.registerPrescription}
                            </span>
                        </IconButton>
                    )}
                    <IconButton
                        className={classes.iconButton}
                        onClick={() => cancelEditing('isCancelButton')}
                    >
                        <span className={`${classes.cancelText}  ${classes.fontText}`}>
                            {messages.cancel}
                        </span>
                    </IconButton>
                </div>
            );
        }
    };
    const handleDeletePrescription = () => {
        dispatch(deletePrescription(prescription.id));
        setAlert({ alert: '', open: false });
    };
    const openDeleteConfirmModal = () => {
        if (!notEditClinical) {
            const drName = `${prescription.prescriber.first_name}  ${prescription.prescriber.last_name}`;
            setAlert({
                text: getConfirmText(drName, getFullDate(prescription.prescribed)),
                open: true
            });
        }
    };
    const getConfirmText = (drName, date) => {
        if (lang === 'fa') {
            return `${messages.alerts.deletePrescription} ${drName} ${messages.alerts.at} ${date} ${messages.alerts.areYouSure}`;
        } else {
            return `${messages.alerts.deletePrescription} ${drName} ${messages.alerts.at} ${date} ?`;
        }
    };
    return (
        <>
            <AlertDialog
                open={alert?.open}
                alertText={alert?.text}
                cancelText={messages.no}
                confirmText={messages.yes}
                handleAction={handleDeletePrescription}
                handleClose={() => setAlert({ alert: '', open: false })}
            />
            <div className={classes.body} data-testid="prescription">
                <form>
                    <PrescriptionHeader
                        prescribed={
                            addNew ? editedPrescription?.prescribed : prescription?.prescribed
                        }
                        addNew={addNew}
                        editable={editable}
                        setEditable={makePrescriptionEditable}
                        handleChangeDate={handleChangeDate}
                        handleDelete={openDeleteConfirmModal}
                        prescriber={prescription?.prescriber}
                        isMobile={isMobile}
                        notEditClinical={notEditClinical}
                    />

                    {editable && !drugs && (
                        <LinearProgress
                            className={classes.drugEditLoader}
                            size={1}
                            thickness={0.01}
                        />
                    )}
                    <div className={classes.drugItemWrapper}>
                        <DrugHeader isMobile={isMobile} />
                        {/* <div className={classes.drugsContainer}> */}
                        {editedPrescription?.prescribed_drugs?.map((drug, index) => {
                            if (editable || addNew) {
                                let mapDrug;
                                if (editable) {
                                    mapDrug = {
                                        drug: drug.drug,
                                        drug_form: drug.drug_form?.id || drug.drug_form,
                                        drug_strength: drug.drug_strength?.id || drug.drug_strength,
                                        description: drug?.description
                                    };
                                }
                                return (
                                    <DrugEdit
                                        drugItem={editable ? mapDrug : drug}
                                        key={drug?.drug ? drug.drug.id : index}
                                        removeDrug={() => handleRemoveDrug(index)}
                                        editDrug={(params) => handleEditDrug(params, index)}
                                        drugs={drugs}
                                        handleSearchDrugs={handleSearchDrugs}
                                        isMobile={isMobile}
                                    />
                                );
                            } else {
                                return (
                                    <>
                                        <DrugView
                                            drugItem={drug}
                                            key={drug.id}
                                            isMobile={isMobile}
                                        />
                                    </>
                                );
                            }
                        })}
                        {/* </div> */}
                    </div>
                    {prescriptionOptions()}
                </form>
            </div>
        </>
    );
};
Prescription.propTypes = {
    prescription: PropTypes.object,
    handleDelete: PropTypes.func,
    addNew: PropTypes.bool,
    patientId: PropTypes.string,
    handleCancel: PropTypes.func,
    notEditClinical: PropTypes.bool
};
export default Prescription;
